import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";
import Popup from "components/WMS/Mobile/Popup";

// Assets
import TrolleyIcon from "assets/img/wms/trolley.svg";

NoTrolleyPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired
};

function NoTrolleyPopup({open, handleClose, onClick}) {

    const Icon = () => (
        <img
            src={TrolleyIcon}
            alt='Trolley'
            style={{
                width: '48px',
                height: '48px',
            }}
        />
    );

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id='wms.sorting.popup.no.trolley.title' />}
            icon={<Icon/>}
            isMobile={true}
            strictOnclose={true}
        >
            <Grid container>
                <Grid
                    container
                    item
                    direction={"column"}
                    gap={2}
                >
                    <CustomButton
                        onClick={onClick}
                        fullWidth={true}
                    >
                        <FormattedMessage id='wms.sorting.popup.no.trolley.refresh' />
                    </CustomButton>
                    <CustomButton
                        onClick={handleClose}
                        color={'default'}
                        fullWidth={true}
                    >
                        <FormattedMessage id='wms.sorting.popup.no.trolley.dashboard' />
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    )
}

export default NoTrolleyPopup;
